import { render, staticRenderFns } from "./SMItem.vue?vue&type=template&id=3d7a55fb&scoped=true&"
import script from "./SMItem.vue?vue&type=script&lang=js&"
export * from "./SMItem.vue?vue&type=script&lang=js&"
import style0 from "./SMItem.vue?vue&type=style&index=0&id=3d7a55fb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7a55fb",
  null
  
)

export default component.exports